import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Store } from '@ngrx/store';
import { combineLatest, filter, map, Observable, Subscription } from 'rxjs';
import { commonFeature } from './shared/store/reducers';
import { setLoading } from './shared/store/actions';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, MatProgressSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'chatbot-webapp';

  loading$: Observable<boolean>;

  private sub = new Subscription();

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private store: Store,
    private router: Router
  ) {
    this.iconRegistry.registerFontClassAlias(
      'material-symbols',
      'material-symbols-outlined'
    );
    this.iconRegistry.addSvgIcon(
      'instagram',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/instagram.svg')
    );
    this.iconRegistry.addSvgIcon(
      'messenger',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/messenger.svg')
    );
    this.iconRegistry.addSvgIcon(
      'whatsapp',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/whatsapp.svg')
    );

    this.loading$ = combineLatest([
      this.store.select(commonFeature.selectHttpCount).pipe(map((x) => x > 0)),
      this.store.select(commonFeature.selectLoading),
    ]).pipe(map(([http, loading]) => http || loading));

    this.sub = this.router.events
      .pipe(
        filter(
          (
            event
          ): event is
            | NavigationStart
            | NavigationEnd
            | NavigationCancel
            | NavigationError =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError
        )
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.store.dispatch(setLoading({ loading: true }));
        } else {
          this.store.dispatch(setLoading({ loading: false }));
        }
      });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
